import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import CatGrooming from './pages/CatGrooming';
import SpaExperiences from './pages/SpaExperiences';
import Training from './pages/Training';
import Team from './pages/Team';
import Contact from './pages/Contact';
import EmmipetDental from './pages/EmmipetDental';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <div className="app">
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/cat-grooming" element={<CatGrooming />} />
          <Route path="/spa-experiences" element={<SpaExperiences />} />
          <Route path="/emmipet-dental" element={<EmmipetDental />} />
          <Route path="/training" element={<Training />} />
          <Route path="/team" element={<Team />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
